import type { ConsentCategory, ConsentCategoryMeta } from "./types";

/**
 * Single source of truth for the consent categories shown in the customize
 * modal, in display order. Adding a tracker that needs a new category means
 * adding an entry here (and the store/types union); existing trackers just
 * reference one of these by `category`.
 */
export const CONSENT_CATEGORIES: ConsentCategoryMeta[] = [
  {
    id: "essential",
    label: "Essential",
    description:
      "Required for the site to work — sign-in, security, and your preferences. Always on.",
    essential: true,
  },
  {
    id: "analytics",
    label: "Analytics",
    description:
      "Anonymous usage statistics that help us understand what to improve.",
    essential: false,
  },
  {
    id: "marketing",
    label: "Marketing",
    description:
      "Lets us measure and improve our advertising across other platforms.",
    essential: false,
  },
];

/** Categories the user can opt into (everything except essential). */
export const NON_ESSENTIAL_CATEGORIES: ConsentCategory[] = CONSENT_CATEGORIES.filter(
  (c) => !c.essential,
).map((c) => c.id);
